// Create a variable to check if we're in development mode
const isDev = process.env.REACT_APP_API_ENV === 'local' || process.env.REACT_APP_API_ENV === 'dev';

// Define base URLs
// const DEV_BASE_URL = 'http://localhost:8000';
const DEV_BASE_URL = 'http://localhost:8000';
// const PROD_BASE_URL = 'http://localhost:8000';
const PROD_BASE_URL = 'https://apigcp.snapmydesign.com';

const API_CONFIG = isDev
  ? {
    PHOTOSHOOT_UPLOAD_URL: `${DEV_BASE_URL}/api/v1/photoshoot/upload`,
    PHOTOSHOOT_GENERATE_URL: `${DEV_BASE_URL}/api/v1/photoshoot/generate`,
    PHOTOSHOOT_CREDIT_COST_URL: `${DEV_BASE_URL}/api/v1/photoshoot/credit-cost`,

    REGISTER_USER_URL: `${DEV_BASE_URL}/api/v1/user/register`,
    GET_USER_CREDITS_URL: `${DEV_BASE_URL}/api/v1/user/credits`,
    PAST_GENERATIONS_URL: `${DEV_BASE_URL}/api/v1/gallery/past-generations`,

    VIRTUAL_TRYON_URL: `${DEV_BASE_URL}/api/v1/tryon/generate`,
    TRYON_CREDIT_COST_URL: `${DEV_BASE_URL}/api/v1/tryon/credit-cost`,
    TRYON_UPLOAD_URL: `${DEV_BASE_URL}/api/v1/tryon/upload`,

    GET_TRYON_MODELS_URL: `${DEV_BASE_URL}/api/v1/tryon/models`,
    GET_POSE_PRESETS_URL: `${DEV_BASE_URL}/api/v1/pose/presets`,
    REALISTIC_TRYON_URL: `${DEV_BASE_URL}/api/v1/realistic-tryon/generate`,
    REALISTIC_TRYON_CREDIT_COST_URL: `${DEV_BASE_URL}/api/v1/realistic-tryon/credit-cost`,
    REALISTIC_TRYON_TEMPLATES_URL: `${DEV_BASE_URL}/api/v1/realistic-tryon/templates`,

    AI_DESIGNER_URL: `${DEV_BASE_URL}/api/v1/ai-designer/generate`,
    AI_DESIGNER_CREDIT_COST_URL: `${DEV_BASE_URL}/api/v1/ai-designer/credit-cost`,
    AI_DESIGNER_UPLOAD_URL: `${DEV_BASE_URL}/api/v1/ai-designer/upload`,
    AI_POSES_URL: `${DEV_BASE_URL}/api/v1/ai-poses/generate`,
    AI_POSES_CREDIT_COST_URL: `${DEV_BASE_URL}/api/v1/ai-poses/credit-cost`,
    AI_POSES_UPLOAD_URL: `${DEV_BASE_URL}/api/v1/ai-poses/upload`,

    BACKGROUND_CHANGE_URL: `${DEV_BASE_URL}/api/v1/background-change/generate`,
    BACKGROUND_CHANGE_CREDIT_COST_URL: `${DEV_BASE_URL}/api/v1/background-change/credit-cost`,
    BACKGROUND_CHANGE_UPLOAD_INPUT_URL: `${DEV_BASE_URL}/api/v1/background-change/upload-input`,
    BACKGROUND_CHANGE_UPLOAD_BACKGROUND_URL: `${DEV_BASE_URL}/api/v1/background-change/upload-background`,
    GET_BACKGROUND_PRESETS_URL: `${DEV_BASE_URL}/api/v1/background-change/presets`,

    FASHION_EXTRACTOR_URL: `${DEV_BASE_URL}/api/v1/fashion-extractor/generate`,
    FASHION_EXTRACTOR_CREDIT_COST_URL: `${DEV_BASE_URL}/api/v1/fashion-extractor/credit-cost`,
    FASHION_EXTRACTOR_UPLOAD_URL: `${DEV_BASE_URL}/api/v1/fashion-extractor/upload`,

    AI_GHOST_MANNEQUIN_URL: `${DEV_BASE_URL}/api/v1/ai-ghost-mannequin/generate`,
    AI_GHOST_MANNEQUIN_CREDIT_COST_URL: `${DEV_BASE_URL}/api/v1/ai-ghost-mannequin/credit-cost`,
    AI_GHOST_MANNEQUIN_UPLOAD_URL: `${DEV_BASE_URL}/api/v1/ai-ghost-mannequin/upload`,

    AI_WRINKLE_REMOVAL_URL: `${DEV_BASE_URL}/api/v1/ai-wrinkle-removal/generate`,
    AI_WRINKLE_REMOVAL_CREDIT_COST_URL: `${DEV_BASE_URL}/api/v1/ai-wrinkle-removal/credit-cost`,
    AI_WRINKLE_REMOVAL_UPLOAD_URL: `${DEV_BASE_URL}/api/v1/ai-wrinkle-removal/upload`,

    VIDEO_GENERATE_URL: `${DEV_BASE_URL}/api/v1/video/generate`,
    VIDEO_CREDIT_COST_URL: `${DEV_BASE_URL}/api/v1/video/credit-cost`,
    VIDEO_TEMPLATES_URL: `${DEV_BASE_URL}/api/v1/video/templates`,
    VIDEO_PROMPT_GENERATE_URL: `${DEV_BASE_URL}/api/v1/video/prompt-generate`,

    CANVAS_UPLOAD_URL: `${DEV_BASE_URL}/api/v1/canvas/upload`,

    UPSCALER_GENERATE_URL: `${DEV_BASE_URL}/api/v1/upscaler/generate`,
    UPSCALER_CREDIT_COST_URL: `${DEV_BASE_URL}/api/v1/upscaler/credit-cost`,

    BACKGROUND_REMOVAL_URL: `${DEV_BASE_URL}/api/v1/background-removal/generate`,
    BACKGROUND_REMOVAL_CREDIT_COST_URL: `${DEV_BASE_URL}/api/v1/background-removal/credit-cost`,

    IMAGE_EDITING_URL: `${DEV_BASE_URL}/api/v1/image-editing/generate`,
    IMAGE_EDITING_CREDIT_COST_URL: `${DEV_BASE_URL}/api/v1/image-editing/credit-cost`,
    IMAGE_EDITING_UPLOAD_URL: `${DEV_BASE_URL}/api/v1/image-editing/upload`,

    AI_WORKFLOW_URL: `${DEV_BASE_URL}/api/v1/ai-workflow/generate`,
    AI_WORKFLOW_UPLOAD_URL: `${DEV_BASE_URL}/api/v1/ai-workflow/upload`,
    AI_WORKFLOW_CREDIT_COST_URL: `${DEV_BASE_URL}/api/v1/ai-workflow/credit-cost`,
    FASHION_CATALOGUE_GENERATE_URL: `${DEV_BASE_URL}/api/v1/ecommerce-catalogue-generator/generate`,
    FASHION_CATALOGUE_PRESETS_URL: `${DEV_BASE_URL}/api/v1/ecommerce-catalogue-generator/presets`,
    FASHION_CATALOGUE_CREDIT_COST_URL: `${DEV_BASE_URL}/api/v1/ecommerce-catalogue-generator/credit-cost`,

    ACTIVE_WEAR_CATALOGUE_PRESETS_URL: `${DEV_BASE_URL}/api/v1/active-wear-catalogue-generator/presets`,
    YOGA_WEAR_CATALOGUE_PRESETS_URL: `${DEV_BASE_URL}/api/v1/yoga-wear-catalogue-generator/presets`,
    WEAR_CATALOGUE_GENERATE_URL: `${DEV_BASE_URL}/api/v1/wear-catalogue-generator/generate`,
    WEAR_CATALOGUE_CREDIT_COST_URL: `${DEV_BASE_URL}/api/v1/wear-catalogue-generator/credit-cost`,
    WEAR_CATALOGUE_UPLOAD_URL: `${DEV_BASE_URL}/api/v1/wear-catalogue-generator/upload`,

    GENERATE_PAYMENT_LINK_URL: `${DEV_BASE_URL}/api/v1/generate-payment-link`,
    GENERATE_PAYMENT_LINK_PHONEPE_URL: `${DEV_BASE_URL}/api/v1/generate-payment-link-phonepe`,

    ORDER_STATUS_URL: `${DEV_BASE_URL}/api/v1/order/status`,
    CREDIT_ORDER_HISTORY_URL: `${DEV_BASE_URL}/api/v1/credit-transactions/order-history`,
    CREDIT_GENERATION_HISTORY_URL: `${DEV_BASE_URL}/api/v1/credit-transactions/generation-history`,
    SUBSCRIPTION_URL: `${DEV_BASE_URL}/api/v1/subscription/status`,
    PROMO_BANNER_URL: `${DEV_BASE_URL}/api/v1/promo-banner`,
    GET_USER_PROFILE_URL: `${DEV_BASE_URL}/api/v1/user/profile-details`,
    UPDATE_USER_NAME_URL: `${DEV_BASE_URL}/api/v1/user/update-name`,
    UNIFIED_PROFILE_UPDATE_URL: `${DEV_BASE_URL}/api/v1/user/profile`,
    DELETE_ACCOUNT_URL: `${DEV_BASE_URL}/api/v1/user/delete-account`,
    VTON_URL: `${DEV_BASE_URL}/api/v1/vton`,
    VTON_UPLOAD_URL: `${DEV_BASE_URL}/api/v1/vton/upload`
  }
  : {
    PHOTOSHOOT_UPLOAD_URL: `${PROD_BASE_URL}/api/v1/photoshoot/upload`,
    PHOTOSHOOT_GENERATE_URL: `${PROD_BASE_URL}/api/v1/photoshoot/generate`,
    PHOTOSHOOT_CREDIT_COST_URL: `${PROD_BASE_URL}/api/v1/photoshoot/credit-cost`,
    REGISTER_USER_URL: `${PROD_BASE_URL}/api/v1/user/register`,
    GET_USER_CREDITS_URL: `${PROD_BASE_URL}/api/v1/user/credits`,
    PAST_GENERATIONS_URL: `${PROD_BASE_URL}/api/v1/gallery/past-generations`,
    VIRTUAL_TRYON_URL: `${PROD_BASE_URL}/api/v1/tryon/generate`,
    TRYON_CREDIT_COST_URL: `${PROD_BASE_URL}/api/v1/tryon/credit-cost`,
    TRYON_UPLOAD_URL: `${PROD_BASE_URL}/api/v1/tryon/upload`,
    GET_TRYON_MODELS_URL: `${PROD_BASE_URL}/api/v1/tryon/models`,
    GET_POSE_PRESETS_URL: `${PROD_BASE_URL}/api/v1/pose/presets`,
    REALISTIC_TRYON_URL: `${PROD_BASE_URL}/api/v1/realistic-tryon/generate`,
    REALISTIC_TRYON_CREDIT_COST_URL: `${PROD_BASE_URL}/api/v1/realistic-tryon/credit-cost`,
    REALISTIC_TRYON_TEMPLATES_URL: `${PROD_BASE_URL}/api/v1/realistic-tryon/templates`,
    AI_DESIGNER_URL: `${PROD_BASE_URL}/api/v1/ai-designer/generate`,
    AI_DESIGNER_CREDIT_COST_URL: `${PROD_BASE_URL}/api/v1/ai-designer/credit-cost`,
    AI_DESIGNER_UPLOAD_URL: `${PROD_BASE_URL}/api/v1/ai-designer/upload`,
    AI_POSES_URL: `${PROD_BASE_URL}/api/v1/ai-poses/generate`,
    AI_POSES_CREDIT_COST_URL: `${PROD_BASE_URL}/api/v1/ai-poses/credit-cost`,
    AI_POSES_UPLOAD_URL: `${PROD_BASE_URL}/api/v1/ai-poses/upload`,
    BACKGROUND_CHANGE_URL: `${PROD_BASE_URL}/api/v1/background-change/generate`,
    BACKGROUND_CHANGE_CREDIT_COST_URL: `${PROD_BASE_URL}/api/v1/background-change/credit-cost`,
    BACKGROUND_CHANGE_UPLOAD_INPUT_URL: `${PROD_BASE_URL}/api/v1/background-change/upload-input`,
    BACKGROUND_CHANGE_UPLOAD_BACKGROUND_URL: `${PROD_BASE_URL}/api/v1/background-change/upload-background`,
    GET_BACKGROUND_PRESETS_URL: `${PROD_BASE_URL}/api/v1/background-change/presets`,
    FASHION_EXTRACTOR_URL: `${PROD_BASE_URL}/api/v1/fashion-extractor/generate`,
    FASHION_EXTRACTOR_CREDIT_COST_URL: `${PROD_BASE_URL}/api/v1/fashion-extractor/credit-cost`,
    FASHION_EXTRACTOR_UPLOAD_URL: `${PROD_BASE_URL}/api/v1/fashion-extractor/upload`,

    AI_GHOST_MANNEQUIN_URL: `${PROD_BASE_URL}/api/v1/ai-ghost-mannequin/generate`,
    AI_GHOST_MANNEQUIN_CREDIT_COST_URL: `${PROD_BASE_URL}/api/v1/ai-ghost-mannequin/credit-cost`,
    AI_GHOST_MANNEQUIN_UPLOAD_URL: `${PROD_BASE_URL}/api/v1/ai-ghost-mannequin/upload`,
    AI_WRINKLE_REMOVAL_URL: `${PROD_BASE_URL}/api/v1/ai-wrinkle-removal/generate`,
    AI_WRINKLE_REMOVAL_CREDIT_COST_URL: `${PROD_BASE_URL}/api/v1/ai-wrinkle-removal/credit-cost`,
    AI_WRINKLE_REMOVAL_UPLOAD_URL: `${PROD_BASE_URL}/api/v1/ai-wrinkle-removal/upload`,
    VIDEO_GENERATE_URL: `${PROD_BASE_URL}/api/v1/video/generate`,
    VIDEO_CREDIT_COST_URL: `${PROD_BASE_URL}/api/v1/video/credit-cost`,
    VIDEO_TEMPLATES_URL: `${PROD_BASE_URL}/api/v1/video/templates`,
    VIDEO_PROMPT_GENERATE_URL: `${PROD_BASE_URL}/api/v1/video/prompt-generate`,
    CANVAS_UPLOAD_URL: `${PROD_BASE_URL}/api/v1/canvas/upload`,
    UPSCALER_GENERATE_URL: `${PROD_BASE_URL}/api/v1/upscaler/generate`,
    UPSCALER_CREDIT_COST_URL: `${PROD_BASE_URL}/api/v1/upscaler/credit-cost`,
    BACKGROUND_REMOVAL_URL: `${PROD_BASE_URL}/api/v1/background-removal/generate`,
    BACKGROUND_REMOVAL_CREDIT_COST_URL: `${PROD_BASE_URL}/api/v1/background-removal/credit-cost`,
    IMAGE_EDITING_URL: `${PROD_BASE_URL}/api/v1/image-editing/generate`,
    IMAGE_EDITING_CREDIT_COST_URL: `${PROD_BASE_URL}/api/v1/image-editing/credit-cost`,
    IMAGE_EDITING_UPLOAD_URL: `${PROD_BASE_URL}/api/v1/image-editing/upload`,

    AI_WORKFLOW_URL: `${PROD_BASE_URL}/api/v1/ai-workflow/generate`,
    AI_WORKFLOW_UPLOAD_URL: `${PROD_BASE_URL}/api/v1/ai-workflow/upload`,
    AI_WORKFLOW_CREDIT_COST_URL: `${PROD_BASE_URL}/api/v1/ai-workflow/credit-cost`,
    FASHION_CATALOGUE_GENERATE_URL: `${PROD_BASE_URL}/api/v1/ecommerce-catalogue-generator/generate`,
    FASHION_CATALOGUE_PRESETS_URL: `${PROD_BASE_URL}/api/v1/ecommerce-catalogue-generator/presets`,
    FASHION_CATALOGUE_CREDIT_COST_URL: `${PROD_BASE_URL}/api/v1/ecommerce-catalogue-generator/credit-cost`,
    ACTIVE_WEAR_CATALOGUE_PRESETS_URL: `${PROD_BASE_URL}/api/v1/active-wear-catalogue-generator/presets`,
    YOGA_WEAR_CATALOGUE_PRESETS_URL: `${PROD_BASE_URL}/api/v1/yoga-wear-catalogue-generator/presets`,
    WEAR_CATALOGUE_GENERATE_URL: `${PROD_BASE_URL}/api/v1/wear-catalogue-generator/generate`,
    WEAR_CATALOGUE_CREDIT_COST_URL: `${PROD_BASE_URL}/api/v1/wear-catalogue-generator/credit-cost`,
    WEAR_CATALOGUE_UPLOAD_URL: `${PROD_BASE_URL}/api/v1/wear-catalogue-generator/upload`,
    GENERATE_PAYMENT_LINK_URL: `${PROD_BASE_URL}/api/v1/generate-payment-link`,
    GENERATE_PAYMENT_LINK_PHONEPE_URL: `${PROD_BASE_URL}/api/v1/generate-payment-link-phonepe`,
    ORDER_STATUS_URL: `${PROD_BASE_URL}/api/v1/order/status`,
    CREDIT_ORDER_HISTORY_URL: `${PROD_BASE_URL}/api/v1/credit-transactions/order-history`,
    CREDIT_GENERATION_HISTORY_URL: `${PROD_BASE_URL}/api/v1/credit-transactions/generation-history`,
    SUBSCRIPTION_URL: `${PROD_BASE_URL}/api/v1/subscription/status`,
    PROMO_BANNER_URL: `${PROD_BASE_URL}/api/v1/promo-banner`,
    GET_USER_PROFILE_URL: `${PROD_BASE_URL}/api/v1/user/profile-details`,
    UPDATE_USER_NAME_URL: `${PROD_BASE_URL}/api/v1/user/update-name`,
    UNIFIED_PROFILE_UPDATE_URL: `${PROD_BASE_URL}/api/v1/user/profile`,
    DELETE_ACCOUNT_URL: `${PROD_BASE_URL}/api/v1/user/delete-account`,
    VTON_URL: `${PROD_BASE_URL}/api/v1/vton`,
    VTON_UPLOAD_URL: `${PROD_BASE_URL}/api/v1/vton/upload`
  };

export default API_CONFIG; 